










import { Component, Vue } from 'vue-property-decorator'
import Menu from '@/router/menu.ts'

@Component({
  name: 'Nav'
})
export default class Nav extends Vue {
  private menuList: any[] = Menu;
}
